import { render, staticRenderFns } from "./UploadCensus.vue?vue&type=template&id=9b930310&"
import script from "./UploadCensus.vue?vue&type=script&lang=js&"
export * from "./UploadCensus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports